<!-- <div style="padding:12px; border-bottom:1px solid #eee; display:flex; align-items:center; justify-content:space-between">
    <div>
        <span *ngIf="username">Utilisateur : <strong>{{ username }}</strong></span>
        <span *ngIf="roles.length" style="margin-left:12px">
            Rôles : <strong>
                <ng-container *ngFor="let role of roles; let i = index">
                    {{ role }}<span *ngIf="i < roles.length - 1">, </span>
                </ng-container>
            </strong>
        </span>
        <span *ngIf="!roles.length" style="margin-left:12px">Rôles : <strong>Aucun</strong></span>
        <span *ngIf="groups.length" style="margin-left:12px">
            Groupes : <strong>{{ groups.join(', ') }}</strong>
        </span>
    </div>
    <div>
        <button *ngIf="username" (click)="logout()">Déconnexion</button>
    </div>
</div>
 -->
<router-outlet></router-outlet>